module.exports = __webpack_public_path__ + "static/media/profile-circle.4ef33d98.svg";